import NotFoundPage from '@brands/Dashboard/NotFoundPage/NotFoundPage';
import useWindowSize from '@brands/hooks/useWindowSize';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectIsAdminLoginNewDesign } from '@brands/store/selectors/isAdminNewDesign';
import { AuthState } from '@brands/store/slices/authSlice';
import React from 'react';
import { isMobile as mobileDetect } from 'react-device-detect';
import { useSelector } from 'react-redux';

import ImageUploadMobileAdminView from '../../../../../default/Dashboard/PatientForms/PatientForm/ImageUpload/ImageMobileUpload';
import ImageUploadWebAdminView from '../../../../../default/Dashboard/PatientForms/PatientForm/ImageUpload/ImageUpload';
import { useAppSelector } from '../../../../hooks/useReduxHook';
import { UserRoleName } from '../../../../services/identity/types/UserProfile';
import ImageUploadMobile from './ImageMobileUpload';
import ImageUploadWeb from './ImageUpload';

const ImageUploadProcessValidation: React.FC = () => {
  let component: JSX.Element;
  const screenSize = useWindowSize();
  const isMobile = screenSize.width < 768;
  const user: AuthState = useAppSelector(selectAuth);
  const isAdminNewDesign = useSelector(selectIsAdminLoginNewDesign);

  const isNewDesignRole =
    user.userInfo?.role.name === UserRoleName.Admin ||
    user.userInfo?.role.name === UserRoleName.SuperAdmin ||
    user.userInfo?.role.name === UserRoleName.OrganizationAdmin ||
    user.userInfo?.role.name === UserRoleName.CareAdvisor ||
    user.userInfo?.role.name === UserRoleName.Collector;
  const useAdminBrandViews = isAdminNewDesign && !isNewDesignRole;

  switch (user.userInfo?.role.name) {
    case UserRoleName.Patient:
    case UserRoleName.Collector:
    case UserRoleName.CareAdvisor:
    case UserRoleName.OrganizationAdmin:
    case UserRoleName.SuperAdmin:
    case UserRoleName.Admin:
      if (isMobile || mobileDetect)
        component = useAdminBrandViews ? <ImageUploadMobileAdminView /> : <ImageUploadMobile />;
      else component = useAdminBrandViews ? <ImageUploadWebAdminView /> : <ImageUploadWeb />;
      break;
    default:
      component = <NotFoundPage />;
      break;
  }

  return <div>{component}</div>;
};

export default ImageUploadProcessValidation;
